export default __webpack_public_path__ + "static/perfect-26bebf7820f78dbd0aabc88ce02d383e.png";